import { render } from "./TaskGroup.vue?vue&type=template&id=387bf4c5&scoped=true"
import script from "./TaskGroup.vue?vue&type=script&lang=js"
export * from "./TaskGroup.vue?vue&type=script&lang=js"

import "./TaskGroup.vue?vue&type=style&index=0&id=387bf4c5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387bf4c5"]])

export default __exports__